export default function OtherProductsGap() {
    const productItems = [
      {
        image: '/Bond_557020320-99-74_01.jpg',
        title: 'Wardrobe Handles',
        link: 'https://nisharhardware.com/categories/drawer-system',
      },
      {
        image: '/BLUM_HK_TOP.jpg',
        title: 'Kitchen Accessories',
        link: 'https://nisharhardware.com/categories/kitchen-accesories',
      },
      {
        image: '/LAMA ON PLATE.jpg',
        title: 'Door Handles',
        link: 'https://nisharhardware.com/categories/door-handles',
      },
    ];
  
    return (
      <section className="bg-white py-20 px-6 md:px-20 font-poppins">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-12">
          {/* Text Column */}
          <div className="md:w-1/2 space-y-6">
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight tracking-tight">
              Explore More
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              We also create other unique and high-demand products. Here's a glimpse of what we offer...
            </p>
          </div>
  
          {/* Image Cards Column */}
          <div className="md:w-1/2 grid grid-cols-1 sm:grid-cols-3 gap-6 w-full">
            {productItems.map((item, index) => (
              <a
                key={index}
                href={item.link}
                className="group relative overflow-hidden rounded-xl shadow-lg border border-gray-100 transition transform hover:scale-105"
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute bottom-0 w-full bg-black/60 text-white text-center py-2 text-sm font-medium">
                  {item.title}
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
    );
  }
  